// import in_memory from './storage/in_memory';
import firebase from './storage/firebase';

// @todo Pick-up required store (in_memory or firebase)

export default firebase;
